import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "key.icon",
  "use": "key.icon-usage",
  "viewBox": "1455.321 -345.055 25.941 14.15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"1455.321 -345.055 25.941 14.15\" id=\"key.icon\"><path d=\"M14.737,10.717a7.075,7.075,0,1,0,0,4.717h5.129V20.15h4.717V15.433h2.358V10.717ZM8.075,15.433a2.358,2.358,0,1,1,2.358-2.358A2.365,2.365,0,0,1,8.075,15.433Z\" transform=\"translate(1454.321 -351.055)\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/key.icon.svg
// module id = mDrW
// module chunks = 13